<template>
  <section>
    <!-- Menu -->
    <top-menu/>

    <section>
      <page-header :headerName="'Relatório de Bugs'" :showBtn="false" :btnName="''" :btnRoute="''"
                   :css="'container-fluid'"/>

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Loading from page -->
            <full-loading v-if="loadingList"/>

            <!-- Filters -->
            <div class="col-xs-12 col-sm-12 col-md-12">
              <div v-if="!loadingList" class="col-xs-12 col-sm-12 col-md-12 default-box filters">
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-6 col-md-3">
                    <div class="form-group">
                      <label for="name">Id da empresa</label>
                      <input v-model="dataSearch.companyId" type="text" class="form-control" id="name" name="name">
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 col-md-12">
                  <button v-on:click="getList()">Pesquisar</button>
                </div>
              </div>
            </div>

            <!-- No Result -->
            <div v-if="!loadingList && (dataList !== '' && !dataList.length) && !failRequest"
                 class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Nenhum resultado encontrado.</p>
              </div>
            </div>

            <!-- Fail Request -->
            <div v-if="!loadingList && failRequest" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box content-default">
                <p>Falha na requisição, tente novamente ou contate os DEVS.</p>
              </div>
            </div>

            <!-- Table -->
            <div v-if="!loadingList && dataList.length" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 default-box orderBy">
                <div class="portlet-title">
                  <div class="caption">
                    <span
                      class="caption-subject font-blue bold uppercase">Quantidade total ({{ dataList.length }})</span>
                  </div>
                </div>

                <div class="portlet-body contate-table offset-top-20">
                  <div class="table-scrollable table-scrollable-borderless">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th> EMPRESA</th>
                        <th> MELHORIA</th>
                        <th> PLATAFORMA</th>
                        <th> MODELO</th>
                        <th> VERSÃO</th>
                        <th> DATA</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(c, index) in dataList">
                        <td><a v-bind:href="'/detalhes-da-empresa/' + c.companyId + '/' + c.contentContext"
                               target="_blank" class="link">{{ c.companyName }}</a></td>
                        <td>{{ c.text }}</td>
                        <td>
                          <span v-if="c.deviceType === 1">1</span>
                          <span v-if="c.deviceType === 2">2</span>
                          <span v-if="c.deviceType === 3">WEB</span>
                        </td>
                        <td>{{ c.deviceModel }}</td>
                        <td>{{ c.version }}</td>
                        <td>{{ c.createdAt | formatDate }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import pageHeader from "../../components/default/pageHeader.vue";

import {
  LIST_BUGS
} from "../../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import moment from "moment";

export default {
  name: "report-bug",
  components: {
    topMenu,
    pageHeader,
    fullLoading,
  },
  data() {
    return {
      failRequest: false,
      loadingChurn: false,
      loadingList: false,
      dataList: [],
      dataSearch: {
        month: '',
        expirationDateMonth: '',
        companyId: '',
        duration: ''
      }
    }
  },
  methods: {
    getList() {
      this.dataList = [];
      this.loadingList = true;
      this.failRequest = false;
      let url = LIST_BUGS;
      url += "?t=kkkk";
      url += "&pageQtd=150";

      if (this.dataSearch.companyId)
        url += "&companyIds=" + this.dataSearch.companyId;

      UTIL_SERVICE.console("URL SEARCH:", url);
      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT LIST_BUGS:", response.data);

        this.dataList = response.data.items;
        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        this.failRequest = true;

        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    }
  },
  beforeMount() {
    this.getList();
  }
}
</script>

<style lang="scss">
.btn-all-excel {
  cursor: pointer;
  margin-left: 5px;
  display: inline-block;
  padding: 8px 10px;
  background-color: #00a651;
  color: #fff;
  margin-bottom: 20px;
  border-radius: 4px !important;
  float: right;
  font-weight: 600;
  margin-top: 0;
  border: none;

  i {
    margin-left: 5px;
  }

  &:hover {
    color: #fff;
    background-color: #008d45;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/reports/reportBug.vue